import Link from 'next/link';
import { useTranslations } from 'next-intl';
import { cn } from '@/lib/utils';
import { MenuPublicItemType } from './MenuPublicConfig';
interface DesktopMenuPublicProps {
  menuItems: MenuPublicItemType[];
  menuItemsAuth: MenuPublicItemType[];
}

export default function DesktopMenuPublic({
  menuItems,
  menuItemsAuth,
}: DesktopMenuPublicProps) {
  const t = useTranslations('menu');
  return (
    <>
      <ul className='hidden md:flex md:flex-1 md:justify-center'>
        {menuItems.map((item) => (
          <li key={item.title} className='group flex items-center'>
            <Link
              href={item.link}
              target='_blank'
              className={cn(
                'text-black-300 after:bg-black-200 hover:text-black-200 relative px-4 py-1 text-xs transition-colors after:absolute after:top-1/2 after:right-0 after:hidden after:h-4 after:w-[1px] after:-translate-y-1/2 after:content-[""] group-last-of-type:after:hidden md:after:block'
              )}
            >
              {t(`${item.title}.title`)}
            </Link>
          </li>
        ))}
      </ul>
      <ul className='hidden min-w-10 md:flex md:justify-center'>
        {menuItemsAuth.map((item) => (
          <li key={item.title} className='flex items-center'>
            <Link
              href={item.link}
              className='text-black-300 relative px-4 py-1 text-xs underline'
            >
              {t(`${item.title}.title`)}
            </Link>
          </li>
        ))}
      </ul>
    </>
  );
}
